// extracted by mini-css-extract-plugin
export default {"full":"Gallery_full__VABuj"};